// extracted by mini-css-extract-plugin
export var container = "LectureVideo-module--container--39445";
export var iframeContainer = "LectureVideo-module--iframe-container--27200";